export default __webpack_public_path__ + "static/media/img-slider-lh-career-3.c8c47a04.png";